import React from 'react';
import { TrevorIcon } from '@trevor/ui-components';

import type { SavedQuery, UUID } from '@/types';
import { ShowMoreButton } from '@/components/ShowMoreButton';
import {
  SavedQueriesItem,
  SavedQueriesList,
  ScrollContainer,
} from '../styled-components';
import { SavedQueryInfo } from './SavedQueryInfo';

const NUM_OF_QUERIES_TO_SHOW = 25;

export type SavedQueriesContainerProps = {
  datasourceId: UUID;
  onSelectQuery: F<SavedQuery>;
  savedQueries: SavedQuery[];
  selectedQuerySeriesId?: Maybe<SavedQuery['series']>;
};

export const SavedQueriesContainer: React.FC<SavedQueriesContainerProps> = ({
  datasourceId,
  onSelectQuery,
  savedQueries,
  selectedQuerySeriesId,
}) => {
  const [numOfQueriesToShow, setNumOfQueriesToShow] = React.useState(
    NUM_OF_QUERIES_TO_SHOW,
  );

  const handleShowMore = (e: React.MouseEvent) => {
    e.stopPropagation();
    setNumOfQueriesToShow((v) => v + NUM_OF_QUERIES_TO_SHOW);
  };

  return savedQueries.length ? (
    <ScrollContainer>
      <SavedQueriesList>
        {savedQueries.slice(0, numOfQueriesToShow).map((query) => (
          <SavedQueriesItem
            key={query.id}
            $selected={query.series === selectedQuerySeriesId}
          >
            <SavedQueryInfo query={query} onSelectQuery={onSelectQuery} />
            <a
              target="_blank"
              href={`/datasources/${datasourceId}/saved-queries/${query.series}`}
            >
              <TrevorIcon name="export" size="sm" $color="#666" />
            </a>
          </SavedQueriesItem>
        ))}
      </SavedQueriesList>
      {savedQueries.length > numOfQueriesToShow && (
        <ShowMoreButton onClick={handleShowMore}>show more</ShowMoreButton>
      )}
    </ScrollContainer>
  ) : (
    <p>
      0 saved queries match your <strong>search</strong>. Clear the search{' '}
      <strong>above</strong> to see all.
    </p>
  );
};
